module.exports = __webpack_public_path__ + "static/sp_checkout_3_2-ebc104b7db799534f50d617b5be4309d.jpg";